import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { es } from "./es";

const LanguageContext = createContext({ lang: "en", setLang: () => {}, t: (s) => s });

export function LanguageProvider({ children }) {
    const [lang, setLangState] = useState(() => {
        try { return localStorage.getItem("lsp-lang") || "en"; } catch { return "en"; }
    });

    const setLang = useCallback((l) => {
        try { localStorage.setItem("lsp-lang", l); } catch {}
        setLangState(l);
    }, []);

    useEffect(() => {
        document.documentElement.lang = lang === "es" ? "es" : "en";
    }, [lang]);

    const t = useCallback((s) => (lang === "es" && es[s]) || s, [lang]);

    return (
        <LanguageContext.Provider value={{ lang, setLang, t }}>
            {children}
        </LanguageContext.Provider>
    );
}

export const useLang = () => useContext(LanguageContext);
